import H from 'constants/httpMethod.const';
import { AUTH_API } from 'middleware/api';
import asArray from 'utils/arrays/asArray.util';
import authenticatedEndpoint from 'utils/backend/authenticatedEndpoint.util';
import jsonEndpoint from 'utils/backend/jsonEndpoint.util';
import logger from 'utils/logger.util';

import {
  UPDATE_APPOINTMENT_WITH_SERVICES_FAILURE,
  UPDATE_APPOINTMENT_WITH_SERVICES_REQUEST,
  UPDATE_APPOINTMENT_WITH_SERVICES_SUCCESS,
} from 'booking/constants';

const ATAG = 'updateAppointmentProcedures';
const L = logger(ATAG);

const fromProcedureToDto = (item) => ({
  id: item?.id,
  start_time: item?.startTime ?? item?.start_time,
  price: item?.price,
  duration: item?.duration,
  processing: item?.processing,
  is_custom_processing: item?.isCustomProcessing ?? item?.is_custom_processing,
  is_custom_duration: item?.isCustomDuration ?? item?.is_custom_duration,
  is_custom_price: item?.isCustomPrice ?? item?.is_custom_price,
  editing: item?.editing,
  stylist_id: item?.stylist?.id ?? item?.stylistId ?? item?.stylist_id,
  service_id: item?.service?.id ?? item?.serviceId ?? item?.service_id,
});

const fromProceduresToDto = (procedures) => asArray(procedures).map(fromProcedureToDto);

const fromDataToDto = (item) => ({
  client_id: item?.clientId ?? item?.client_id,
  notes: item?.notes,
  procedures: fromProceduresToDto(item?.procedures),
});

const updateAppointmentProcedures = (options) => {
  const { appointmentId, salonId, appointmentDetails, data } = options ?? {};

  // NOTE: dto is for BE, fixing bugs introduced from the call site of this function
  const dto = fromDataToDto(data);
  L.debug('()', dto, '<-', data, '<-', options);

  return {
    ATAG,
    [AUTH_API]: {
      ...authenticatedEndpoint(),
      ...jsonEndpoint(H.put, `salon/${salonId}/appointment/${appointmentId}/`, dto),
      types: [
        UPDATE_APPOINTMENT_WITH_SERVICES_REQUEST,
        UPDATE_APPOINTMENT_WITH_SERVICES_SUCCESS,
        UPDATE_APPOINTMENT_WITH_SERVICES_FAILURE,
      ],
      params: {
        salonId,
        appointmentId,
        data,
        method: H.put,
        appointmentDetails,
      },
    },
  };
};

// noinspection JSUnusedGlobalSymbols
export default updateAppointmentProcedures;
